import useDefinedContext from "hooks/useDefinedContext";
import ChartScalesContext from "../contexts/ChartScalesContext";

function useXScale() {
  const scales = useDefinedContext(ChartScalesContext);

  return scales.x;
}
export default useXScale;
